import {BaseApiModel} from "../../../../../infrastructure/models/base-api-model";
import {makeObservable, observable} from 'mobx';
export class OddsRateModel extends BaseApiModel {
  @observable decimal: Number;
  @observable fractional: String;
  @observable american: String;

  constructor(model: OddsRateModel) {
    super(model);

    this.decimal = model.decimal;
    this.fractional = model.fractional;
    this.american = model.american;

    makeObservable(this);
  }
}
